import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaSnapchatGhost,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaFacebookF,
  FaHome,
  FaInfoCircle,
  FaHandshake,
  FaLock,
  FaEnvelopeOpenText,
  FaIdCard,
  FaHeadset,
  FaFileContract,
  FaCalendarCheck,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import imageelogo from "../../assets/image/1-04.png";
import "./Footer.css";

export default function Footer() {
  return (
    <footer
      className="text-white pt-5 pb-3 mt-auto border-top"
      dir="rtl"
      style={{ background: "rgb(187, 3, 21)" }}
    >
      <div className="container" style={{ marginTop: "0" }}>
        <div className="row gy-4">
          {/* Logo and Description */}
          <div className="col-md-4 text-md-end text-center">
            <div className="d-flex flex-column align-items-start align-items-md-end">
              <img
                src={imageelogo}
                alt="Tanzeem Logo"
                height="60"
                className="mb-2"
                style={{ alignSelf: "start" }}
              />

              <p className="text-light small text-start text-md-end m-0">
                شركة مختصه في تقديم افضل الاسعار والاحتارفيه العاليه وجدوه
                ممتازه
              </p>

              <div className="footer-support-box mt-3">
                <strong>خدمة العملاء والشكاوى 24/7</strong>
                <span>
                  نلتزم بالرد على الاستفسارات والشكاوى المتعلقة بالخدمات المقدمة
                  على مدار الساعة طوال أيام الأسبوع.
                </span>
              </div>
            </div>
          </div>

          {/* Useful Links */}
          <div className="col-md-4 d-flex flex-column align-items-start align-items-md-center justify-content-start text-end text-md-center">
            <h5 className="mb-3" style={{ color: "#fff" }}>
              روابط تهمك
            </h5>

            <ul className="list-unstyled text-light d-flex flex-column align-items-start gap-2 mb-3 py-1">
              <li className="d-flex align-items-center gap-2">
                <FaHome style={{ color: "#fff" }} />
                <Link to="/" className="text-white text-decoration-none">
                  الرئيسية
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaEnvelopeOpenText style={{ color: "#fff" }} />
                <Link to="/contact" className="text-white text-decoration-none">
                  تواصل معنا
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaHeadset style={{ color: "#fff" }} />
                <Link
                  to="/support-complaints"
                  className="text-white text-decoration-none"
                >
                  الدعم والشكاوى 24/7
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaCalendarCheck style={{ color: "#fff" }} />
                <Link to="/contact" className="text-white text-decoration-none">
                  طلب خدمة / استعلام
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaFileContract style={{ color: "#fff" }} />
                <Link
                  to="/cancellation-policy"
                  className="text-white text-decoration-none"
                >
                  سياسة الإلغاء والتعديل
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaInfoCircle style={{ color: "#fff" }} />
                <Link to="/about" className="text-white text-decoration-none">
                  من نحن
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaHandshake style={{ color: "#fff" }} />
                <Link to="/terms" className="text-white text-decoration-none">
                  الشروط والأحكام
                </Link>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaLock style={{ color: "#fff" }} />
                <Link to="/privacy" className="text-white text-decoration-none">
                  سياسة الخصوصية
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-4">
            <h5 className="mb-3" style={{ color: "#fff" }}>
              تواصل معنا
            </h5>

            <p className="d-flex align-items-center gap-2">
              <FaPhoneAlt style={{ color: "#fff" }} />
              <a
                href="tel:920033239"
                className="text-white text-decoration-none"
              >
                920-0332-39
              </a>
            </p>

            <p className="d-flex align-items-center gap-2">
              <FaEnvelope style={{ color: "#fff" }} />
              <a
                href="mailto:info@tnzeem.com"
                className="text-white text-decoration-none"
              >
                info@tnzeem.com
              </a>
            </p>

            <p className="d-flex align-items-start gap-2">
              <FaMapMarkerAlt style={{ color: "#fff" }} />
              <span>
                طريق عرفات، الدار البيضاء، الرياض 14517، المملكة العربية
                السعودية
              </span>
            </p>

            <hr className="border-light opacity-50" />

            <p className="d-flex align-items-center gap-2">
              <FaIdCard style={{ color: "#fff" }} />
              <span>
                الاسم التجاري: <strong>التنظيم للسفر والسياحة</strong>
              </span>
            </p>

            <p className="d-flex align-items-center gap-2">
              <FaIdCard style={{ color: "#fff" }} />
              <span>
                السجل التجاري:{" "}
                <Link
                  to="/trade-register"
                  className="text-white text-decoration-underline"
                >
                  <strong>7033309043</strong>
                </Link>
              </span>
            </p>

            <p className="d-flex align-items-center gap-2">
              <FaIdCard style={{ color: "#fff" }} />
              <span>
                الترخيص السياحي:{" "}
                <Link
                  to="/tourismlicense"
                  className="text-white text-decoration-underline"
                >
                  <strong>73104281</strong>
                </Link>
              </span>
            </p>

            <p className="d-flex align-items-center gap-2">
              <FaIdCard style={{ color: "#fff" }} />
              <span>
                فئة الترخيص: <strong>وكالة السفر والسياحة</strong>
              </span>
            </p>

            {/*<div className="d-flex gap-3 mt-3 fs-5">
              <a
                href="https://www.snapchat.com/add/tnzeem_ksa"
                target="_blank"
                rel="noreferrer"
                className="text-warning"
                aria-label="تابعنا على سناب شات"
              >
                <FaSnapchatGhost />
              </a>

              <a
                href="https://www.instagram.com/tnzeem_ksa/"
                target="_blank"
                rel="noreferrer"
                className="text-white"
                aria-label="تابعنا على إنستجرام"
              >
                <FaInstagram />
              </a>

              <a
                href="http://tiktok.com/@tnzeem_ksa"
                target="_blank"
                rel="noreferrer"
                className="text-white"
                aria-label="تابعنا على تيك توك"
              >
                <FaTiktok />
              </a>

              <a
                href="https://www.youtube.com/@tnzeem_ksa"
                target="_blank"
                rel="noreferrer"
                className="text-white"
                aria-label="تابعنا على يوتيوب"
              >
                <FaYoutube />
              </a>

              <a
                href="https://www.facebook.com/tnzeemksa/"
                target="_blank"
                rel="noreferrer"
                className="text-primary"
                aria-label="تابعنا على فيسبوك"
              >
                <FaFacebookF />
              </a>
            </div>*/}
          </div>
        </div>

        <div
          className="text-center pt-4 mt-4 border-top border-secondary"
          dir="ltr"
        >
          <small className="text-white">
            &copy; {new Date().getFullYear()} tnzeem.com. جميع الحقوق محفوظة.
          </small>
        </div>
      </div>
    </footer>
  );
}
